import "styles/pages/page-thank-you.scss";
import React from "react";
import { Link } from "gatsby";
import Layout from "components/Layout";
import Seo from "components/Seo";

const ThanksPage = () => {
  return (
    <Layout is404={true}>
      <Seo title="Dziękujemy" />
      <section className="thanks-page">
        <div className="container">
          <img
            src={require("assets/images/thanks-img.png").default}
            alt=""
            className="img-fluid thanks-page__img"
          />
          <h1 className="thanks-page__title">
            Dziękujemy! Twoja wiadomość została wysłana!
          </h1>
          <div className="thanks-page__text">
            Skorzystanie z formularza kontaktowego oznacza zgodę otrzymywanie od
            Elcamp RV sp. z.o.o. z siedzibą w Krakowie informacji zwrotnych na
            wskazany adres email i/lub podany nr telefonu. <br />
            <br /> Zgodę możesz odwołać w każdym momencie ze skutkiem na
            przyszłość. <br /> Szczegóły w naszej{" "}
            <Link to="/ogolne-warunki-sprzedazy-i-gwarancji#polityka-prywatnosci">
              Polityce Prywatności
            </Link>
            .
          </div>
          <Link to="/" className="btn btn--with-icon">
            &#171; Wróć
            <img src={require("assets/icons/vehicle-btn.svg").default} alt="" />
          </Link>
        </div>
      </section>
      <div className="error-page-footer">
        <div className="container">
          <div className="error-page-footer__text">
            &copy; 2021 Elcamp RV sp. z o.o. ul. Tyniecka 118e, 30-376 Kraków
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ThanksPage;
